"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _EnvSwitcher = _interopRequireDefault(require("./EnvSwitcher"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "env-switcher": "DefaultTheme__env-switcher___2qP_X",
  "env-button": "DefaultTheme__env-button___3ZADX",
  "modal": "DefaultTheme__modal___3OWrQ",
  "modal-body": "DefaultTheme__modal-body___1cW23",
  "modal-footer": "DefaultTheme__modal-footer___2GYTs",
  "env-item": "DefaultTheme__env-item___FPywS",
  "active": "DefaultTheme__active___nMdTR",
  "no-env-message": "DefaultTheme__no-env-message___1nd9A",
  "env-item-title": "DefaultTheme__env-item-title___1w9lG",
  "mark": "DefaultTheme__mark___3FR7b",
  "mark-active": "DefaultTheme__mark-active___1cWRk",
  "mark-default": "DefaultTheme__mark-default___w9TNi",
  "anchor": "DefaultTheme__anchor___D3-41",
  "envSwitcher": "DefaultTheme__env-switcher___2qP_X",
  "envButton": "DefaultTheme__env-button___3ZADX",
  "modalBody": "DefaultTheme__modal-body___1cW23",
  "modalFooter": "DefaultTheme__modal-footer___2GYTs",
  "envItem": "DefaultTheme__env-item___FPywS",
  "noEnvMessage": "DefaultTheme__no-env-message___1nd9A",
  "envItemTitle": "DefaultTheme__env-item-title___1w9lG",
  "markActive": "DefaultTheme__mark-active___1cWRk",
  "markDefault": "DefaultTheme__mark-default___w9TNi"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "env-button": "DarkTheme__env-button___d9enZ",
  "env-item": "DarkTheme__env-item___tJrec",
  "active": "DarkTheme__active___3-4tT",
  "envButton": "DarkTheme__env-button___d9enZ",
  "envItem": "DarkTheme__env-item___tJrec"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "env-item": "LumeTheme__env-item___2leG6",
  "env-button": "LumeTheme__env-button___2Vb9Y",
  "mark-active": "LumeTheme__mark-active___DCIfR",
  "anchor": "LumeTheme__anchor___1nIid",
  "envItem": "LumeTheme__env-item___2leG6",
  "envButton": "LumeTheme__env-button___2Vb9Y",
  "markActive": "LumeTheme__mark-active___DCIfR"
};
require("../../components/Modal/themes/DefaultTheme.css");
var ModalDefaultTheme = {
  "overlay": "DefaultTheme__overlay___3AceM",
  "modal": "DefaultTheme__modal___21WiE"
};
require("../../components/ModalHeader/themes/DefaultTheme.css");
var ModalHeaderDefaultTheme = {
  "modal-header": "DefaultTheme__modal-header___3-lo2",
  "danger": "DefaultTheme__danger___2Gh6V",
  "close": "DefaultTheme__close___3T_6-",
  "modalHeader": "DefaultTheme__modal-header___3-lo2"
};
require("../../components/ModalBody/themes/DefaultTheme.css");
var ModalBodyDefaultTheme = {
  "modal-body": "DefaultTheme__modal-body___26GPu",
  "modalBody": "DefaultTheme__modal-body___26GPu"
};
require("../../components/ModalFooter/themes/DefaultTheme.css");
var ModalFooterDefaultTheme = {
  "modal-footer": "DefaultTheme__modal-footer___YOV-y",
  "modalFooter": "DefaultTheme__modal-footer___YOV-y"
};
require("../../components/Button/themes/DefaultTheme.css");
var ButtonDefaultTheme = {
  "button": "DefaultTheme__button___29mtS",
  "primary": "DefaultTheme__primary___249es",
  "neutral": "DefaultTheme__neutral___3ZBg8",
  "no-fill": "DefaultTheme__no-fill___1Pw4q",
  "secondary": "DefaultTheme__secondary___1JUnQ",
  "tertiary": "DefaultTheme__tertiary___3cLHz",
  "flat": "DefaultTheme__flat___1g85K",
  "danger": "DefaultTheme__danger___hdJjA",
  "inverse": "DefaultTheme__inverse___i4aAH",
  "sm": "DefaultTheme__sm___IcJN8",
  "spinner": "DefaultTheme__spinner___1NECm",
  "md": "DefaultTheme__md___1s5qL",
  "lg": "DefaultTheme__lg___o_Th1",
  "circular": "DefaultTheme__circular___3nFPO",
  "is-loading": "DefaultTheme__is-loading___z_iqy",
  "children": "DefaultTheme__children___WfQFi",
  "noFill": "DefaultTheme__no-fill___1Pw4q",
  "isLoading": "DefaultTheme__is-loading___z_iqy"
};
require("../../components/Modal/themes/DarkTheme.css");
var ModalDarkTheme = {
  "modal": "DarkTheme__modal___WXbn-"
};
require("../../components/ModalHeader/themes/DarkTheme.css");
var ModalHeaderDarkTheme = {
  "modal-header": "DarkTheme__modal-header___1_GCa",
  "modalHeader": "DarkTheme__modal-header___1_GCa"
};
require("../../components/ModalBody/themes/DarkTheme.css");
var ModalBodyDarkTheme = {
  "modal-body": "DarkTheme__modal-body___2nPs0",
  "modalBody": "DarkTheme__modal-body___2nPs0"
};
require("../../components/ModalFooter/themes/DarkTheme.css");
var ModalFooterDarkTheme = {
  "modal-footer": "DarkTheme__modal-footer___33zUk",
  "modalFooter": "DarkTheme__modal-footer___33zUk"
};
require("../../components/Button/themes/DarkTheme.css");
var ButtonDarkTheme = {
  "button": "DarkTheme__button___2kIdG",
  "disabled": "DarkTheme__disabled___1M4kT",
  "no-fill": "DarkTheme__no-fill___2QrWc",
  "primary": "DarkTheme__primary___3Uk1Z",
  "secondary": "DarkTheme__secondary___2kdte",
  "tertiary": "DarkTheme__tertiary___2Ictb",
  "flat": "DarkTheme__flat___Z46o6",
  "danger": "DarkTheme__danger___38aEz",
  "noFill": "DarkTheme__no-fill___2QrWc"
};
require("../../components/Modal/themes/LumeTheme.css");
var ModalLumeTheme = {
  "overlay": "LumeTheme__overlay___15lKd",
  "modal": "LumeTheme__modal___3H3BK"
};
require("../../components/ModalHeader/themes/LumeTheme.css");
var ModalHeaderLumeTheme = {
  "modal-header": "LumeTheme__modal-header___2mmkW",
  "modalHeader": "LumeTheme__modal-header___2mmkW"
};
require("../../components/ModalBody/themes/LumeTheme.css");
var ModalBodyLumeTheme = {
  "modal-body": "LumeTheme__modal-body___3CL7a",
  "modalBody": "LumeTheme__modal-body___3CL7a"
};
require("../../components/ModalFooter/themes/LumeTheme.css");
var ModalFooterLumeTheme = {
  "modal-footer": "LumeTheme__modal-footer___20f-j",
  "modalFooter": "LumeTheme__modal-footer___20f-j"
};
require("../../components/Button/themes/LumeTheme.css");
var ButtonLumeTheme = {
  "button": "LumeTheme__button___2d3zl"
};
DefaultTheme.Modal = ModalDefaultTheme;
DefaultTheme.ModalHeader = ModalHeaderDefaultTheme;
DefaultTheme.ModalBody = ModalBodyDefaultTheme;
DefaultTheme.ModalFooter = ModalFooterDefaultTheme;
DefaultTheme.Button = ButtonDefaultTheme;
DarkTheme.Modal = ModalDarkTheme;
DarkTheme.ModalHeader = ModalHeaderDarkTheme;
DarkTheme.ModalBody = ModalBodyDarkTheme;
DarkTheme.ModalFooter = ModalFooterDarkTheme;
DarkTheme.Button = ButtonDarkTheme;
LumeTheme.Modal = ModalLumeTheme;
LumeTheme.ModalHeader = ModalHeaderLumeTheme;
LumeTheme.ModalBody = ModalBodyLumeTheme;
LumeTheme.ModalFooter = ModalFooterLumeTheme;
LumeTheme.Button = ButtonLumeTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_EnvSwitcher["default"].displayName, themes.DefaultTheme)(_EnvSwitcher["default"]);
ThemedComponent.displayName = _EnvSwitcher["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map